// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"82ec60ac87c0ee0b35ab","454":"aa6b34125db60de32fa7"}[chunkId] + ".js";
};